export default "__VITE_ASSET__f4ecdcd1__"